// extracted by mini-css-extract-plugin
export default {"carousel":"DG-z"};